export class EntOrganicproducersFilter {
    page: number;
    size: number;
    deleted: boolean;
    name?: string;
    legalFormId?: number;
    regionId?: number;
    areaId?: number;
    territorialUnitId?: number;
    registrationDate?: string;
    certificationBody?: string;
    certificationNumber?: string;
    validUntil?: string;
    statusId?: number;
    year?: number;
    animalTypeId?: number;
    productTypeId?: number;
  
    constructor(init?: Partial<EntOrganicproducersFilter>) {
      this.page = 1;
      this.size = 30;
      this.deleted = false;
      if (init) {
        Object.assign(this, init)
      }
    }
  }
    